import React from "react"
import { useSelector } from "react-redux"

import { PUBLISHED, UNPUBLISHED } from "const"
import { StoreType, QidCompanyFilters } from "client/store"
import { PublishedUnpublished } from "client/utils"
import {
    SearchBar,
    SearchFilter,
} from "client/components"

interface SearchQidCompany {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    shortView?: boolean
    filters: QidCompanyFilters
    onFilter: (filters: QidCompanyFilters) => void
}

const statusArray = [PUBLISHED, UNPUBLISHED]

const QidCompanySearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    shortView = false,
    filters,
    onFilter,
}: SearchQidCompany) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    if (shortView) {
        return (
            <SearchBar
                id={id}
                filters={filters}
                leftOffset={leftOffset}
                rightOffset={rightOffset}
                onFilter={onFilter}
            />
        )
    }

    const popupFilters: SearchFilter[] = []

    statusArray.forEach((status: PublishedUnpublished) => {
        popupFilters.push({
            title: lang[status],
            isActive: filters.status === status,
            onAdd: (obj: QidCompanyFilters) => ({
                ...obj,
                status,
            }),
            onClose: (obj: QidCompanyFilters) => ({
                ...obj,
                status: null,
            }),
        })
    })

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            popupFilters={popupFilters}
            onFilter={onFilter}
        />
    )
}
export default QidCompanySearch
